<li class="right-sidebar-item static sm:relative">
  <a
    class="right-sidebar-button relative z-50"
    pStyleClass="@next"
    enterActiveClass="animate-scalein"
    leaveActiveClass="animate-fadeout"
    leaveToClass="hidden"
    [hideOnOutsideClick]="true"
    (click)="onNotifications()"
  >
    @if (unreadNotificationsCount() > 0) {
      <span
        class="flex items-center justify-center rounded-full absolute text-white"
        style="
          width: 15px;
          height: 15px;
          top: 4px;
          right: 3px;
          font-size: 8px;
          font-weight: 400;
          background: red;
        "
      >
        {{
          unreadNotificationsCount() > 99 ? '99+' : unreadNotificationsCount()
        }}
      </span>
    }
    <i
      [class]="
        notificationPreference().pushAll ? 'pi pi-bell' : 'pi pi-bell-slash'
      "
    ></i>
  </a>
  <div
    class="list-none m-0 py-4 px-4 rounded-3xl border border-surface absolute bg-surface-0 dark:bg-surface-900 overflow-hidden hidden origin-top min-w-72 sm:w-[24rem] mt-2 right-0 z-50 top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
    style="right: -60px; height: 80vh; width: 340px; overflow: auto"
  >
    <div class="flex items-center gap-2 justify-between">
      <span class="text-lg font-medium text-surface-950 dark:text-surface-0">{{
        'notificacoes' | translate
      }}</span>
      <!--
      <button
        pRipple
        class="text-surface-700 dark:text-surface-300 text-sm font-medium"
        >
        Mark all as read
      </button>
    --></div>
    <div
      class="my-2 shadow-custom-shadow border border-surface-200 dark:border-surface-800 bg-white/55 dark:bg-white/8 flex items-center gap-2 rounded-full p-1"
    >
      @for (item of notificationsBars(); let i = $index; track i) {
        <button
          [ngClass]="{
            'bg-primary-100 dark:bg-primary-900':
              selectedNotificationBar() === item.id,
            'hover:bg-primary-100/30 dark:hover:bg-primary-900/30':
              selectedNotificationBar() !== item.id,
          }"
          class="rounded-full p-2 flex-1 flex items-center justify-center transition-all"
          (click)="selectedNotificationBar.set(item.id)"
        >
          <span
            class="capitalize font-medium text-surface-950 dark:text-surface-0"
            >{{ item.label }}</span
          >
          @if (item.badge) {
            <span
              class="ml-1 text-xs bg-primary-500 text-white rounded-full px-2 py-0.5"
            >
              {{ item.badge() }}
            </span>
          }
        </button>
      }
    </div>
    <ul class="flex flex-col gap-8">
      @for (item of selectedNotificationsBarData(); let i = $index; track i) {
        <li
          class="flex gap-3 cursor-pointer"
          (click)="handleNotificationClick(item)"
        >
          <div class="flex flex-col items-center gap-1">
            <span class="flex-1 w-px bg-surface-200 dark:bg-surface-800"></span>
          </div>
          <div class="flex-1 pt-2 space-y-2">
            <div class="flex items-center justify-between gap-2">
              <span class="font-medium text-surface-950 dark:text-surface-0">{{
                getTipoExibicao(item.type)
              }}</span>
              <div
                class="text-sm text-surface-700 dark:text-surface-200 flex items-center gap-1"
              >
                <!--
                  {{ formatTime(item.createdAt) }}
                  -->
                @if (!item.viewed) {
                  <div class="!w-2 !h-2 rounded-full bg-green-500"></div>
                }
              </div>
            </div>
            <div
              class="p-2 bg-surface-100 dark:bg-surface-800 border border-surface rounded-lg"
            >
              <div
                class="text-sm text-surface-700 dark:text-surface-200 space-y-1"
              >
                <!-- Câmera (se existir) - com truncamento individual -->
                @if (item.camera?.title) {
                  <div class="truncate">Câmera: {{ item.camera.title }}</div>
                }

                <!-- Título (se existir) -->
                @if (item.message?.title) {
                  <div class="truncate">
                    {{ item.message.title }}
                  </div>
                }

                <!-- Área (se existir) -->
                @if (item.message?.areaTitle) {
                  <div class="truncate">Área: {{ item.message.areaTitle }}</div>
                }

                <!-- Usuário (se existir) -->
                @if (item.message?.userName) {
                  <div class="truncate">
                    Usuário: {{ item.message.userName }}
                  </div>
                }

                <!-- Placa (se existir) -->
                @if (item.message?.plate) {
                  <div class="truncate">Placa: {{ item.message.plate }}</div>
                }
              </div>
            </div>
          </div>
        </li>
      } @empty {
        <li class="text-center py-4 text-surface-500">
          Nenhuma notificação
          {{ selectedNotificationBar() === 'unread' ? 'não lida' : 'lida' }}
        </li>
      }
    </ul>
  </div>
</li>
